import {
  StyledLimitsContainer,
  StyledContainer,
  StyledLimitsWrapper,
  StyledUsedTypography,
  StyledTypography,
  StyledTotalTypography,
  StyledLinearProgress,
  StyledPaper,
  StyledPaperWrapper,
  StyledPaperTypography,
  StyledLink,
  StyledExpirationInfoTypography,
  StyledCreditsBox,
  StyledCreditsAmount,
  StyledCreditsLabel,
} from './styled';
import { PRICING_PATH } from '../../../../../../constants';
import userApi from '../../../../../../api/userApi';
import { formatAmount } from '../../../../../../helpers/format';

type Props = {
  apiKey: string;
};

const PaygUsage = ({ apiKey }: Props) => {
  const { data } = userApi.useGetAccountCreditsQuery({
    apiKey,
  });

  const { paygCredits = 0 } = data || {};

  return (
    <StyledContainer>
      <StyledCreditsBox>
        <StyledCreditsAmount>{formatAmount(paygCredits)}</StyledCreditsAmount>
        <StyledCreditsLabel>credits left</StyledCreditsLabel>
      </StyledCreditsBox>
      <StyledExpirationInfoTypography>
        Credits are deducted per track generation. Top up anytime — no
        subscription required.
      </StyledExpirationInfoTypography>
      <StyledPaper>
        <StyledPaperWrapper>
          <StyledPaperTypography>
            <strong>Save 25%</strong> on track generations with our Subscription
            plan. Switch to a monthly subscription and pay only $0.15 per track
            generation.
          </StyledPaperTypography>
          <StyledLink to={PRICING_PATH}>View Pricing</StyledLink>
        </StyledPaperWrapper>
      </StyledPaper>
    </StyledContainer>
  );
};

export default PaygUsage;
